/**
 * The red stag — the animal the Great Hunt is a rehearsal for (M2-05).
 *
 * Built to be *hard to catch rather than hard to kill*, which is the whole
 * design of hunting it: a stag has no armour worth the name and dies to one
 * good spear thrust, and you will never get to make one, because it can see
 * across a valley and outrun anything in it.
 *
 * Two things are deliberate. The forelegs carry a heavier hit weight than the
 * hind because a stag that has decided you are a problem comes at you front-on
 * and rears; and the antlers are a part with no capability at all, so that
 * shearing one off is a thing the wound tables can narrate without crippling
 * an animal that does not need them to live.
 */
import { quadruped } from './quadruped.js';
export const STAG_PLAN = quadruped({
    id: 'stag',
    name: 'stag',
    foreleg: 'foreleg',
    hindleg: 'haunch',
    foot: 'hoof',
    // Front-heavy: a cornered stag rears and strikes down with the forehooves.
    foreWeight: 1.4,
    skull: 0.7,
    extras: [
        {
            id: 'antler.left',
            zone: 'head',
            side: 'left',
            name: 'near antler',
            hitWeight: 0.5,
            // Bone that does nothing but win arguments. Losing one costs the animal
            // nothing it needs to survive the winter, which is why it is shed.
            contributes: {},
            contains: ['bone'],
        },
        {
            id: 'antler.right',
            zone: 'head',
            side: 'right',
            name: 'off antler',
            hitWeight: 0.5,
            contributes: {},
            contains: ['bone'],
        },
    ],
});
//# sourceMappingURL=stag.js.map